import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  openModalButton: {
    marginTop: '$space4',
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
  },
  buttonContainerDesktop: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  buttonDesktop: {
    flex: 1,
  },
});
